(function () {
  function initRoot(root) {
    if (!root || root.dataset.ucDesignBound === '1') return;
    root.dataset.ucDesignBound = '1';

    var trigger = (root.getAttribute('data-trigger') || 'please design').toLowerCase();
    var optionName = root.getAttribute('data-option-name') || 'Design';
    var notes = root.querySelector('[data-uc-design-notes]');
    var errorEl = root.querySelector('[data-uc-design-error]');
    if (!notes) return;

    function selectedDesignValue() {
      var fieldsets = document.querySelectorAll('.product-form__input, variant-selects, variant-radios');
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend, .form__label');
        var labelText = legend ? legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
        if (labelText.indexOf(optionName.toLowerCase()) === -1 && labelText.indexOf('design') === -1) {
          continue;
        }
        var checked = fieldsets[i].querySelector('input:checked');
        if (checked) return (checked.value || checked.getAttribute('value') || '').trim();
        var select = fieldsets[i].querySelector('select');
        if (select) return (select.value || '').trim();
      }

      var picks = document.querySelectorAll(
        'input[type="radio"][name*="Design"]:checked, input[type="radio"][data-option-name*="Design" i]:checked'
      );
      if (picks.length) return (picks[0].value || '').trim();

      var variantText = document.querySelector('[data-uc-design-request]') &&
        document.querySelector('.product__title, .product .price__regular');
      return '';
    }

    function needsNotes(value) {
      return String(value || selectedDesignValue()).toLowerCase().indexOf(trigger) !== -1;
    }

    function setActive(active) {
      root.hidden = !active;
      notes.disabled = !active;
      if (active) {
        notes.setAttribute('required', 'required');
        notes.setAttribute('aria-required', 'true');
        notes.setAttribute('name', 'properties[Design request]');
      } else {
        notes.removeAttribute('required');
        notes.removeAttribute('aria-required');
        notes.removeAttribute('name');
        notes.value = '';
        hideError();
      }
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
    }

    function showError() {
      if (!errorEl) return;
      errorEl.hidden = false;
      notes.focus();
    }

    function validate() {
      if (root.hidden || notes.disabled) {
        hideError();
        try {
          notes.setCustomValidity('');
        } catch (e) {}
        return true;
      }
      var ok = notes.value.trim().length > 0;
      if (ok) {
        hideError();
        try {
          notes.setCustomValidity('');
        } catch (e) {}
      } else {
        try {
          notes.setCustomValidity('Please fill out this field.');
        } catch (e) {}
        if (typeof notes.reportValidity === 'function') notes.reportValidity();
        else showError();
      }
      return ok;
    }

    function syncFromVariant(variant) {
      var value = '';
      if (variant && variant.options) {
        var options = document.querySelector('variant-selects, variant-radios');
        var names = [];
        if (options && options.dataset && options.dataset.options) {
          try {
            names = JSON.parse(options.dataset.options);
          } catch (e) {}
        }
        if (!names.length) {
          var productOptions = document.querySelectorAll('.product-form__input legend, .product-form__input .form__label');
          // fall through to selectedDesignValue
        }
        for (var i = 0; i < variant.options.length; i++) {
          var optVal = variant.options[i];
          if (String(optVal).toLowerCase().indexOf(trigger) !== -1 || String(optVal).toLowerCase().indexOf('own design') !== -1) {
            value = optVal;
            break;
          }
        }
        if (!value && variant.options.length === 1) value = variant.options[0];
      }
      if (!value) value = selectedDesignValue();
      setActive(needsNotes(value));
    }

    setActive(needsNotes(selectedDesignValue()));

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t) return;
      if (t.matches('input[type="radio"], select') && t.closest('.product-form__input, variant-selects, variant-radios, .product-info')) {
        setTimeout(function () {
          setActive(needsNotes(selectedDesignValue()));
        }, 0);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        syncFromVariant(event && event.data && event.data.variant);
      });
    }

    notes.addEventListener('input', hideError);

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]')) return;
        var linked = notes.getAttribute('form');
        if (linked && form.id && linked !== form.id) return;
        if (!linked) {
          var host = notes.closest('product-form');
          if (host && !host.contains(form)) return;
          if (!host && !form.contains(notes)) return;
        }
        if (!validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest('[type="submit"][name="add"], .product-form__submit');
        if (!btn) return;
        var form = btn.closest('form');
        if (!form) return;
        var linked = notes.getAttribute('form');
        if (linked && form.id && linked !== form.id) return;
        if (!linked) {
          var host = notes.closest('product-form');
          if (host && !host.contains(btn)) return;
          if (!host && !form.contains(notes)) return;
        }
        if (!validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function boot() {
    document.querySelectorAll('[data-uc-design-request]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
